export const FULL_SUPPORT = "Full Support";
export const MAINTENANCE_SUPPORT = "Maintenance Support";
export const EXTENDED_SUPPORT = "Extended Support";
export const END_OF_MAINTENANCE = "End of Maintenance";
export const END_OF_LIFE = "End of life";
export const UNCATEGORIZED = "";

export const FULL_SUPPORT_ClASS = "full-support";
export const MAINTENANCE_SUPPORT_CLASS = "maintenance-support";
export const EXTENDED_SUPPORT_CLASS = "extended-support";
export const END_OF_LIFE_CLASS = "end-of-life";
export const END_OF_MAINTENANCE_CLASS = "end-of-maintenance";
